import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // static targets = ["toggleable"];

  connect() {
    console.log("Filters controller connected");
  }

  toggleSorting() {
    console.log("Toggle sorting");
    document.querySelector("#sorting").classList.toggle("hidden");
  }
  openFilters() {
    console.log("Open drawer filters");
    document.querySelector("#drawer_filters").classList.remove("hidden");
    // overflow hidden on body
    document.body.classList.add("overflow-x-hidden", "overflow-y-hidden");
  }
  closeFilters() {
    console.log("Close drawer filters");
    document.querySelector("#drawer_filters").classList.add("hidden");
    // overflow hidden on body

  }

  sortFirst() {
    console.log("Sort first");
    document.querySelector("#sort_first").classList.add("bg-gray-100");
    document.querySelector("#sort_second").classList.remove("bg-gray-100");
    document.querySelector("#sort_third").classList.remove("bg-gray-100");
    document.querySelector("#sort_fifth").classList.remove("bg-gray-100");

    const cards = document.querySelector("#results")
    const children = [...cards.children];
    children.sort((a, b) => {
      return parseInt(a.querySelector("#price_value").innerText) > parseInt(b.querySelector("#price_value").innerText) ? 1 : -1;
    })

    cards.innerHTML = "";
    children.forEach(item => cards.appendChild(item));
    this.toggleSorting();
  }
  sortSecond() {
    console.log("Sort second");
    document.querySelector("#sort_first").classList.remove("bg-gray-100");
    document.querySelector("#sort_second").classList.add("bg-gray-100");
    document.querySelector("#sort_third").classList.remove("bg-gray-100");
    document.querySelector("#sort_fifth").classList.remove("bg-gray-100");

    const cards = document.querySelector("#results")
    const children = [...cards.children];
    children.sort((a, b) => {
      return parseInt(a.querySelector("#price_value").innerText) < parseInt(b.querySelector("#price_value").innerText) ? 1 : -1;
    })

    cards.innerHTML = "";
    children.forEach(item => cards.appendChild(item));
    this.toggleSorting();
  }
  sortThird() {
    console.log("Sort third");
    document.querySelector("#sort_first").classList.remove("bg-gray-100");
    document.querySelector("#sort_second").classList.remove("bg-gray-100");
    document.querySelector("#sort_third").classList.add("bg-gray-100");
    document.querySelector("#sort_fifth").classList.remove("bg-gray-100");

    const cards = document.querySelector("#results")
    const children = [...cards.children];
    children.sort((a, b) => {
      return parseInt(a.querySelector("#year_value").innerText) < parseInt(b.querySelector("#year_value").innerText) ? 1 : -1;
    })

    cards.innerHTML = "";
    children.forEach(item => cards.appendChild(item));
    this.toggleSorting();
  }
  sortFifth() {
    console.log("Sort fifth");
    document.querySelector("#sort_first").classList.remove("bg-gray-100");
    document.querySelector("#sort_second").classList.remove("bg-gray-100");
    document.querySelector("#sort_third").classList.remove("bg-gray-100");
    document.querySelector("#sort_fifth").classList.add("bg-gray-100");

    const cards = document.querySelector("#results")
    const children = [...cards.children];
    children.sort((a, b) => {
      return parseInt(a.querySelector("#bookings_count_value").innerText) < parseInt(b.querySelector("#bookings_count_value").innerText) ? 1 : -1;
    })

    cards.innerHTML = "";
    children.forEach(item => cards.appendChild(item));
    this.toggleSorting();
  }

  showAllFilters() {
    console.log("Show all filters");
    document.querySelector("#all_filters").classList.toggle("hidden");
    // document.querySelector("#show_less_filters").classList.remove("active");
    // document.querySelector("#filters").classList.remove("d-none");
  }

  removeFilters() {
    document.getElementById("filter_manual").classList.remove("border", "border-gray-500");
    document.getElementById("filter_auto").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.add("border", "border-gray-500");
    let cars = document.querySelectorAll(".car");
    cars.forEach((car) => {
      car.classList.remove("hidden");
    });
  }
  manualFilter() {
    document.getElementById("filter_manual").classList.add("border", "border-gray-500");
    document.getElementById("filter_auto").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.remove("border", "border-gray-500");
    document.querySelectorAll(".automatic").forEach((car) => {
      car.classList.add("hidden");
    });
    document.querySelectorAll(".manual").forEach((car) => {
      car.classList.remove("hidden");
    });
  }
  automaticFilter() {
    document.getElementById("filter_auto").classList.add("border", "border-gray-500");
    document.getElementById("filter_manual").classList.remove("border", "border-gray-500");
    document.getElementById("remove_filters").classList.remove("border", "border-gray-500");
    document.querySelectorAll(".manual").forEach((car) => {
      car.classList.add("hidden");
    });
    document.querySelectorAll(".automatic").forEach((car) => {
      car.classList.remove("hidden");
    });
  }
}
